module.exports = __webpack_public_path__ + "img/button_frame.bbd9f716.png";